<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import wx from "weixin-js-sdk";
export default {
  name: 'App'
}
</script>

<style scoped lang="less">

</style>
